// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1zyom","bigColWidth":"Table_bigColWidth__Xof18","biggerColWidth":"Table_biggerColWidth__36T5s","row":"Table_row__cB8BP","col":"Table_col__ICcSg"};